import { unizEsimUrl } from '../../../settings'

export const getUatTokenUrl = () => {
    return unizEsimUrl + '/esim/getUatToken'
}

export const getDestinationsUrl = () => {
    return unizEsimUrl + '/esim/getDestinations'
}

export const getPackagesUrl = () => {
    return unizEsimUrl + '/esim/getPackages'
}

export const applyPackageUrl = () => {
    return unizEsimUrl + '/esim/applyPackage'
}

export const fetchPackageDataUrl = () => {
    return unizEsimUrl + '/esim/fetchEsimDetails'
}

export const getBearerTokenUrl = () => {
    return unizEsimUrl + '/get-bearer-token'
}

export const getPackageListUrl = () => {
    return unizEsimUrl + '/get-package-list'
}
export const payPaymentUrl = () => {
    return unizEsimUrl + '/esim/processPayment'
}

export const updateEsimPaymentUrl = () => {
    return unizEsimUrl + '/esim/updatePayment'
}

export const getSingleEsimUrl = () => {
    return unizEsimUrl + '/esim/getSingleEsim'
}
